import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Button, ArrowIcon } from "@/components/index";
import { LANDING_SELECTORS } from "@/utils/landing/landing.constants";

import styles from "./ButtonArrow.module.scss";

const ButtonArrow = ({ id, secondary, className }) => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    const page = document.getElementById(id);
    page.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className={classNames(styles["root"], className)}>
      <Button
        data-id={id}
        className={classNames(styles["button"], LANDING_SELECTORS.buttonArrowClass.substring(1))}
        variant={Button.variant.outline}
        color={secondary ? Button.color.light : Button.color.quaternary}
        onClick={handleButtonClick}>
        <ArrowIcon className={styles["icon"]} size="1.2rem" variant="arrow" direction="down" />
      </Button>
    </div>
  );
};

ButtonArrow.propTypes = {
  id: PropTypes.string,
  secondary: PropTypes.bool,
  className: PropTypes.string,
};

export default ButtonArrow;
